import React from 'react';
import EditIcon from './EditIcon';
import styles from './RecoverySection.mod.css';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

const RecoverySection = ({
  title,
  editLink = '',
  children,
  placeholder,
  userColor
}) => {
  const isEditing = children && editLink;
  return (
    <section className={cx('wrapper')}>
      <div className={cx('title-wrapper')}>
        <h3>{title}</h3>
        {isEditing && <EditIcon editLink={editLink} color={userColor} />}
      </div>
      {children ? children : <p className={cx('placeholder')}>{placeholder}</p>}
    </section>
  );
};

export default RecoverySection;



// WEBPACK FOOTER //
// ./src/containers/RecoveryPlan/components/RecoverySection.jsx